/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const _ = require('lodash');

const PaymentPlanActions = require('../../actions/PaymentPlanActions.jsx');
const PaymentPlanStore = require('../../stores/PaymentPlanStore.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');

const DialogRenderer = require('../renderers/DialogRenderer.jsx');

const PaymentPlanSection = React.createClass({
  mixins: [Reflux.connect(PaymentPlanStore, 'paymentPlan')],

  id: null,

  componentWillMount() {
    this.id = Date.now();
  },

  getInitialState() {
    return {
      processing: false,
      paymentPlanMarkup: null
    }
  },

  handleCheckbox(e) {
    PaymentPlanActions.setActive(e.target.checked);
  },

  calculatePayments() {
    let price = AnswerStore.getPrice() || AnswerStore.getStartingAtPrice();
    window.balapp.paymentPlans.displayPayment(price, this.displayPayments);

    this.setState({processing: true}, () => {
      this.refs.paymentPlanDialog.showDialog();
    });
  },

  displayPayments(paymentPlanData) {
    let paymentPlanMarkup = this.buildPPMarkup(JSON.parse(paymentPlanData));
    this.setState({
      processing: false,
      paymentPlanMarkup: paymentPlanMarkup
    });
  },

  buildPPMarkup(paymentPlanData) {
    return (
      <div className="uc-pp-info">
        <h5>Estimated Payments for three payments option</h5>
        <div>(Estimate does not include tax or Packaging and Handling)</div>

        <table cellSpacing="0">
          <thead>
            <tr>
              <td>Installment No.</td>
              <td>Due Date</td>
              <td>Estimated Amount</td>
            </tr>
          </thead>
          <tbody>
            {_.map(paymentPlanData.payments, (paymentItem, i) => {
              return (
                <tr key={i}>
                  <td>{paymentItem.number}{paymentItem.ordinal ? <sup>{paymentItem.ordinal}</sup> : null}</td>
                  <td>{paymentItem.date}</td>
                  <td className="uc-pp-info-amount">{paymentItem.amount}</td>
                </tr>
              );
            })}

            <tr className="uc-pp-info-totals">
              <td colSpan="2">Estimated Total</td>
              <td className="uc-pp-info-amount">{paymentPlanData.total}</td>
            </tr>

            <tr className="uc-pp-info-totals uc-pp-info-down-pymt">
              <td colSpan="2">Estimated Down Payment</td>
              <td className="uc-pp-info-amount">{paymentPlanData.downpayment}</td>
            </tr>

            <tr className="uc-pp-info-totals">
              <td colSpan="2">Amount to be Paid Later</td>
              <td className="uc-pp-info-amount">{paymentPlanData.remainder}</td>
            </tr>
          </tbody>
        </table>

        <ul>
          {_.map(paymentPlanData.note_data, (note, i) => {
            return <li key={i}>{note}</li>;
          })}
        </ul>
      </div>
    );
  },

  render() {
    return (
      <div className="uc-pp-section">
        <div className="uc-pp-checkbox">
          <label className="uc-checkbox" htmlFor={'uc-pp-cb-' + this.id} role="checkbox">
            <input 
              id={'uc-pp-cb-' + this.id} 
              type="checkbox" 
              onChange={this.handleCheckbox} 
              checked={this.state.paymentPlan.active} />
            Use Payment Plan
          </label>
        </div>

        <div className="uc-pp-info-link">
          <a onClick={this.calculatePayments}>
            Plan Details
          </a>
        </div>

        <DialogRenderer 
          ref="paymentPlanDialog" 
          title="<h1>Payment Plan Details</h1>"
          subtitle="Make your purchase more affordable by spreading the cost into three payments. There will be other payment options in the shopping cart, including PayPal and PayPal Credit, which is six payments, with credit approval."
          buttons={[{ text: 'OK', btnClass: 'uc-primary-btn' }]}>
          {
            this.state.processing ? 
            <i className='uc-loading-spinner fa fa-spinner'> </i> :
            this.state.paymentPlanMarkup
          }
        </DialogRenderer>
      </div>
    );
  }
});

module.exports = PaymentPlanSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/PaymentPlanSection.jsx